<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="12" sm="8" md="6" lg="6">
        <a @click="redirectToLogin">
          <v-img
            id="login-logo"
            :src="$store.getters['config/getOrganizationLogo']"
            contain
          ></v-img>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "AppBar",
  methods: {
    redirectToLogin() {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped></style>
